import React, { Component } from 'react';
import { Form, Button } from 'antd';
import { connect } from 'react-redux';

import { INCROWD_ANSWERS_URL } from '../../../config';
import { RootState } from '../../../slices/rootReducer';
import { selectors as authSelectors } from '../../../slices/auth';

import styles from './login.module.scss';

interface StateProps {
  webClientId: string | null;
}
interface LoginForIncrowdProps {
  children: React.ReactNode;
}

const validateMessages = {
  required: 'Required',
  types: {
    email: 'Invalid'
  }
};

type Props = LoginForIncrowdProps & StateProps;

class LoginForIncrowdBase extends Component<Props> {

  constructor(props: Props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  private handleSubmit(): void {
    window.location.assign(INCROWD_ANSWERS_URL);
  }

  render(): React.ReactNode {
    const { children } = this.props;
    return (
      <Form onFinish={this.handleSubmit} validateMessages={validateMessages}>
        <div className={styles.submitButton}>
          <Button htmlType="submit" type="primary">Sign In</Button>
        </div>
        {children}
      </Form>
    );
  }
}

const mapStateToProps = (state: RootState) => ({
  webClientId: authSelectors.getWebClientId(state)
});

export const LoginForIncrowd = connect(mapStateToProps)(LoginForIncrowdBase);
